<i18n src="./resources/locales.json"></i18n>
<template>
  <section class="sms-side-panel" id="sms-side-panel">
    <div class="sms-side-panel-header">
      <div class="sms-side-panel-title">
        <v-tooltip right :disabled="$vuetify.breakpoint.mobile">
          <template v-slot:activator="{ on, attrs }">
            <v-icon id="sms-create-new-message-btn" size="20" v-bind="attrs" v-on="on" @click="openNewMessage">
              mdi-message-text
            </v-icon>
          </template>
          <span class="tooltip-text">{{ $t('sidePanel.create') }}</span>
        </v-tooltip>
      </div>
      <v-item-group id="sms-navigation" class="sms-side-panel-tabs" mandatory>
        <v-row class="ma-0">
          <v-col class="pa-0" cols="4">
            <v-item class="sms-side-panel-tab" v-slot:default="{}">
              <div
                ref="sms-messages-tab"
                id="sms-messages-tab"
                :class="currentTab === tabName.messages ? 'tab-selected' : 'tab-not-selected'"
                @click="
                  changeTab(tabName.messages);
                "
              >
                <v-badge color="primary" :content="totalUnreadMessages" :value="totalUnreadMessages">
                  {{ $t('sidePanel.menuMessage') }}
                </v-badge>
              </div>
            </v-item>
          </v-col>
          <v-col class="pa-0" offset="1" cols="4">
            <v-item class="sms-side-panel-tab" v-slot:default="{}">
              <div
                id="sms-contacts-tab"
                :class="currentTab === tabName.contacts ? 'tab-selected' : 'tab-not-selected'"
                @click="
                  changeTab(tabName.contacts);
                "
              >
                {{ $t('sidePanel.menuContacts') }}
              </div>
            </v-item>
          </v-col>
          <v-col class="pa-0" offset="1" cols="1">
            <v-item class="sms-side-panel-tab" v-slot:default="{}">
              <div
                id="sms-settings-tab"
                class="tab-settings"
                :class="currentTab ===  tabName.settings ? 'tab-selected' : 'tab-not-selected'"
                @click="
                  changeTab(tabName.settings);
                "
              >
                <v-tooltip right :disabled="$vuetify.breakpoint.mobile">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="18" v-bind="attrs" v-on="on">mdi-cog</v-icon>
                  </template>
                  <span class="tooltip-text">{{ $t('sidePanel.menuSettings') }}</span>
                </v-tooltip>
              </div>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </div>

    <div v-if="currentTab === tabName.messages" class="side-panel-container">
      <SmsConversationsSidePanel />
    </div>
    <div v-if="currentTab === tabName.contacts" class="side-panel-container">
      <SmsContactSidePanel />
    </div>
    <div v-if="currentTab === tabName.settings" class="side-panel-container">
      <SmsSettingsSidePanel />
    </div>
  </section>
</template>

<script>
import SmsConversationsSidePanel from './SmsConversationsSidePanel';
import SmsContactSidePanel from './SmsContactSidePanel';
import SmsSettingsSidePanel from './SmsSettingsSidePanel';
import { mapActions, mapGetters } from 'vuex';
import { TAB_NAME } from '@/constants/tabNameConstants';

export default {
  name: 'SmsSidePanel',

  components: { SmsContactSidePanel, SmsConversationsSidePanel, SmsSettingsSidePanel },

  data() {
    return {
      tabName: { ...TAB_NAME }
    };
  },

  computed: {
    ...mapGetters('conversationsV2', ['allConversations', 'getUnreadConversations']),
    ...mapGetters('preferences', ['currentTab', 'getSettings']),

    totalUnreadMessages() {
      let totalNumber = 0;
      this.getUnreadConversations.forEach(conversation => {
        totalNumber += conversation.unreadMessages;
      });
      return totalNumber;
    }
  },

  methods: {
    ...mapActions('conversationsV2', ['startConversation']),
    ...mapActions('preferences', ['updateSettings']),

    openNewMessage() {
      this.startConversation(null);
      this.$root.$emit('close-sidebar');
    },

    changeTab(tabName) {
      const settingObject = this.getSettings;
      settingObject.interfaceState.currentTab = tabName;
      this.updateSettings(settingObject);
    },
  },

  created() {
    this.$root.$on('change-to-messages-tab', () => this.changeTab(this.tabName.messages));
  },

  beforeDestroy() {
    this.$root.$off('change-to-messages-tab');
  }
};
</script>

<style scoped>
.sms-side-panel {
  height: 100vh;
  width: 100%;
  overflow-y: hidden;
  border-right: 1px solid var(--v-surface-border-darken1);
}

.side-panel-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100% - 60px);
  width: 100%;
}

.sms-side-panel-header {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--v-surface-border-darken1);
}

.sms-side-panel-title {
  display: flex;
  float: left;
  width: 70px;
  font-size: 25px;
  margin-top: 15px;
  padding: 8px;
  justify-content: center;
  align-items: center;
}

.sms-side-panel-tabs {
  float: right;
  margin-top: 23px;
  width: calc(100% - 70px);
}

.sms-side-panel-tab {
  cursor: pointer;
  font-size: 0.8rem;
  text-transform: capitalize;
  text-align: center;
}

.sms-side-panel-tab:hover {
  border-bottom: 4px solid var(--v-primary-lighten1);
  opacity: 1;
  padding-bottom: 14px;
}

.tab-selected {
  border-bottom: 4px solid var(--v-primary-base);
  color: var(--v-primary-base);
  font-weight: bolder;
  padding-bottom: 14px;
}

.tab-selected .v-icon {
  color: var(--v-primary-base);
}

.tab-not-selected {
  opacity: 0.7;
}

.tooltip-text {
  text-transform: capitalize;
}

.tab-settings {
  font-size: 0;
}

.sms-side-panel-tab .v-badge__badge {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primary-button-font-color-base) !important;
}
</style>
